import styles from "./addNode.module.css";

const AddNode = () => {
  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData("application/reactflow", nodeType);
    event.dataTransfer.effectAllowed = "move";
  };

  return (
    <div
      className={styles.add_flow}
      onDragStart={(event) => onDragStart(event, "default")}
      draggable
    >
      Noeud vierge
    </div>
  );
};

export default AddNode;
